/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_Items_Count_OneInputs */

const en_tl_items_count_one = /** @type {(inputs: Tl_Items_Count_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 item`)
};

const de_tl_items_count_one = /** @type {(inputs: Tl_Items_Count_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Vorgang`)
};

/**
* | output |
* | --- |
* | "1 item" |
*
* @param {Tl_Items_Count_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_items_count_one = /** @type {((inputs?: Tl_Items_Count_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Items_Count_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_items_count_one(inputs)
	return en_tl_items_count_one(inputs)
});